export class Laboratorio {
    id: string;
    codigoLaboratorio: string;
    nombre: string;
    referencia: string;
}